module.exports = "/assets/638af9d115a128590d090ffdd27f2522.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WY.png
// module id = 3096
// module chunks = 0